/**
 *
 * @param {{query: string, variables: any}} query
 * @param {AbortController | null} abortController
 * @returns
 */
export async function FGStorefrontGraphQL(query, abortController = null) {
  // @ts-ignore
  const response = await fetch(`/api/${FG_STOREFRONT_GRAPHQL_API_VERSION}/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      // @ts-ignore
      'X-Shopify-Storefront-Access-Token': FG_STOREFRONT_PUBLIC_ACCESS_TOKEN,
    },
    signal: abortController ? abortController.signal : null,
    body: JSON.stringify(query),
  });
  return response;
}